<template>
  <div class="masechtos-page page-container pt-3 pb-4">
    <div data-v-7ff3b87d="" class="text-center font-size-lg" style="font-size: 1.2rem">
      <div>Mishna Illuminated Shiurim series is dedicated</div>
      <div>לעלוי נשמת ר' אברהם נחמן בן זאב ז"ל</div>
      <div>By: Wolfson family</div>
    </div>
    <div class="title d-flex align-items-center mb-2">
      <h3 class="mr-2">{{ $_t('KW:masechtos') }}</h3>
      <div class="ml-5">
        <b-input-group class>
          <b-form-input :placeholder="$_t('KW:search')" v-model="filterBooks"></b-form-input>
          <b-input-group-text :slot="isRTL ? 'prepend' : 'append'">
            <i class="fa fa-search"></i>
          </b-input-group-text>
        </b-input-group>
      </div>
    </div>

    <transition-group tag="div" name="fade" class="row">
      <seder v-for="seder in filteredBooks" :key="seder.id" :seder="seder" class="mb-5" type="mishna"></seder>
    </transition-group>
  </div>
</template>
<script>
import SederComponent from './masechtos/Seder';
export default {
  metaInfo: function () {
    return {
      title: this.isComponent ? null : this.$_t('components:masechtos.selectMasechta'),
    };
  },
  components: {
    Seder: SederComponent,
  },
  props: ['isComponent'],
  data: function () {
    return {
      loading: false,
      books: null,
      filterBooks: '',
    };
  },
  created: function () {
    this.getData();
  },
  watch: {
    //$route: "getData"
  },
  methods: {
    getData: function () {
      var self = this;
      this.books = null;
      this.loading = true;
      this.$http.get('/api/books').then(function (response) {
        self.books = response.data;
        self.loading = false;
      });
    },
  },
  computed: {
    filteredBooks: function () {
      if (this.filterBooks == '') {
        return this.books;
      } else {
        var searchRegex = new RegExp(this.filterBooks, 'i');
        var searchedArray = [];
        var books = JSON.parse(JSON.stringify(this.books));
        books.forEach(function (value) {
          var tmpFilter = value.books.filter(function (book) {
            return searchRegex.test(book.name) || searchRegex.test(book.name_hebrew);
          });
          if (tmpFilter.length > 0) {
            var tmp = value;
            tmp.books = tmpFilter;
            searchedArray.push(tmp);
          }
        });
        return searchedArray;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  div {
    // flex-grow: 1;
    input {
      border-radius: 20px 0 0 20px;
      border-right: none;
      padding-left: 20px;
    }
    .input-group-append .input-group-text {
      max-width: 50px;
      border-radius: 0 20px 20px 0;
      border-left: none;
      background: none;

      .fa {
        font-size: 1.1rem;
      }
    }
  }
}
</style>